import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import FarmerStats from "../../components/Admin/FarmerStats";
import AreaSplitChart from "../../components/Admin/AreaSplitChart";
import CoverageStatus from "../../components/Admin/CoverageStatus";
import NutrientProfile from "../../components/Admin/NutrientProfile";
import SoilQuality from "../../components/Admin/SoilQuality";
import FarmAppLogo from "../../assets/logo/FarmAppLogo.png";
import { useTranslation } from "react-i18next";
import { currentDate } from "../../globals/utils";

const AdminReportHeader = () => {
  const { t } = useTranslation();
  return (
    <Paper
      sx={{
        bgcolor: "#237D41",
        color: "white",
        px: 2,
        py: 3,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: 0,
        boxShadow: 0,
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          {t("Overview summary report of your farms")}
        </Typography>
      </Box>
      <Box
        component="img"
        src={FarmAppLogo}
        alt="Farm App Logo"
        sx={{
          width: 100,
          height: "auto",
          bgcolor: "white",
          padding: "10px 50px",
          borderRadius: 1,
        }}
      />
    </Paper>
  );
};

const AdminReportSubHeader = ({ text }) => {
  return (
    <Box sx={{ bgcolor: "#237D41CC", color: "white", p: 1 }}>
      <Typography sx={{ textAlign: "center" }}>{text}</Typography>
    </Box>
  );
};

const AdminReportPage = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ maxWidth: 800, margin: "auto" }}>
      <AdminReportHeader />
      <Grid container spacing={2} sx={{ p: 3 }}>
        <Grid
          item
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Typography sx={{ color: "#237D41", fontWeight: 600 }}>
            {t("Report Date")}:
          </Typography>
        </Grid>
        <Grid
          item
          sx={{
            bgcolor: "#237D411A",
            padding: "10px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography sx={{ color: "#237D41" }}>{currentDate()}</Typography>
        </Grid>
      </Grid>

      <Paper>
        <Box
          sx={{
            breakInside: "avoid",
            pageBreakInside: "avoid",
            mb: 5,
          }}
        >
          <FarmerStats />
        </Box>

        <Grid container>
          <Grid item xs={12} sm={6}>
            <AdminReportSubHeader text={t("Farm Analysis")} />
            <Box sx={{ py: 5 }}>
              <AreaSplitChart />
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <AdminReportSubHeader text={t("Satellite Data and IoT Coverage")} />
            <Box sx={{ py: 5 }}>
              <CoverageStatus />
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            breakInside: "avoid",
            pageBreakInside: "avoid",
          }}
        >
          <AdminReportSubHeader text={t("Nutrient Profile")} />
          <NutrientProfile />
        </Box>

        <Box
          sx={{
            breakInside: "avoid",
            pageBreakInside: "avoid",
          }}
        >
          <AdminReportSubHeader text={t("Soil Quality")} />
          <SoilQuality />
        </Box>

        {/* <AdminReportSubHeader
            text={t("Crop Monitoring (Satellite Metrics)")}
          />
          <Box sx={{ px: 2, py: 3 }}>
            <List sx={{ bgcolor: "#ffffff", boxShadow: "#C3BCBC40" }}>
              <CropMonitoringReport />
            </List>
          </Box> */}
      </Paper>
    </Box>
  );
};

export default AdminReportPage;
